import styled from 'styled-components';
import { PRIMARY } from '../../styles/colors';

// ConversionArrow Styles
export const ConversionArrowContainer = (styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 15%;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const ConversionDot = (styled.div`
  width: 8px;
  height: 8px;
  aspect-ratio: 1;
  border-radius: 100%;
  border: 1px solid ${PRIMARY};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const ConversionLine = (styled.div`
  width: 100%;
  height: 1px;
  background-color: ${PRIMARY};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const ConversionIconContainer = (styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${PRIMARY};
  border-radius: 100%;
  padding: 8px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
